import { Link } from "react-router-dom";
import { Check, Minus, ArrowRight } from "lucide-react";

const WIRED = { sku: "MPRT", slug: "myson-mprt-programmable-room-thermostat-hard-wired-version", label: "MPRT Hard Wired", price: "£92.00" };
const RF = { sku: "MPRTRF", slug: "myson-mprt-rf-wireless-programmable-room-thermostat", label: "MPRT RF Wireless", price: "£108.00" };

const ROWS = [
  ["Connection", "2-wire cable to boiler / wiring centre", "Wireless (433.92 MHz, ~30m) to relay box"],
  ["Power", "230V AC mains", "Room unit 3× AA (~2 yrs) + 230V relay"],
  ["Positioning", "Fixed where the cable is", "Move it to any room"],
  ["Best for", "Replacing an existing wired stat", "Retrofit with no cable runs"],
  ["Programming", "24-hour / 7-day", "24-hour / 7-day"],
  ["Smart Start & 3 temp levels", true, true],
  ["1-hour boost & manual override", true, true],
  ["Temperature range", "6–32°C", "6–32°C"],
  ["Floortec underfloor compatible", true, true],
];

const Cell = ({ v }) => (v === true ? <Check className="w-4 h-4 text-primary" /> : v === false ? <Minus className="w-4 h-4 text-muted-foreground" /> : <span>{v}</span>);

export const MprtComparison = ({ sku }) => {
  if (sku !== WIRED.sku && sku !== RF.sku) return null;
  const other = sku === WIRED.sku ? RF : WIRED;
  return (
    <section className="mt-16" data-testid="mprt-comparison">
      <span className="text-overline text-primary">Wired vs wireless</span>
      <h2 className="mt-2 text-2xl font-display font-bold tracking-tight">Which Myson MPRT do you need?</h2>
      <div className="mt-6 overflow-x-auto border border-border rounded-sm bg-white">
        <table className="w-full text-sm" data-testid="mprt-comparison-table">
          <thead>
            <tr className="border-b border-border bg-muted/40 text-left">
              <th className="p-3 w-1/3 font-semibold">Feature</th>
              {[WIRED, RF].map((m) => (
                <th key={m.sku} className={`p-3 font-semibold ${m.sku === sku ? "text-primary" : ""}`}>
                  {m.label} <span className="block text-xs font-normal text-muted-foreground">{m.price}{m.sku === sku ? " · this product" : ""}</span>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ROWS.map(([k, a, b]) => (
              <tr key={k} className="border-b border-border/60 last:border-0">
                <td className="p-3 font-medium">{k}</td>
                <td className="p-3 text-muted-foreground"><Cell v={a} /></td>
                <td className="p-3 text-muted-foreground"><Cell v={b} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Link to={`/products/${other.slug}`} data-testid="mprt-comparison-switch"
        className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-primary hover:gap-3 transition-all">
        View the {other.label} ({other.price}) <ArrowRight className="w-4 h-4" />
      </Link>
    </section>
  );
};
